import { Transfer, type DataResponse, type ITransfer } from '@talos/kyoko';

export interface InitiateTransferResponse {
  transferID?: string;
  clientID?: string;
  transfer?: Transfer;
}

export function parseInitiateTransferResponse(response: DataResponse<ITransfer>): InitiateTransferResponse {
  const record = response.data?.at(0);
  if (record == null) {
    return {};
  }

  const transfer = new Transfer(record);
  return {
    transferID: transfer.TransferID,
    clientID: transfer.ClientID,
    transfer,
  };
}
